const token =
    "AAPK75623c0730eb419fa888925545234346pD-HnyXlkqZvNRACnmTUn2AbdOZEA8EZYZ_3PH9d1VNxVbRdjAo4lq3Y83DdJuQJ";
export default token;
